import type { TrackChangesPluginOptions } from '@atlaskit/editor-plugin-track-changes';
import { fg } from '@atlaskit/platform-feature-flags';

type Props = {
	options: TrackChangesPluginOptions | undefined;
};

// eslint-disable-next-line jsdoc/require-jsdoc
export function trackChangesPluginOptions({
	options,
}: Props): TrackChangesPluginOptions | undefined {
	return {
		ButtonWrapper: options?.ButtonWrapper,
		showOnToolbar: fg('platform_editor_toolbar_aifc_undo_redo_confluence'),
	};
}
